<template>
    <!-- 列表页的更多-推送至微信收款-推送给续费联系人 -->
    <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'small' }"
        :cancel-button-props="{ size: 'small' }" title="确定推送付款二维码到续费联系人微信吗？" placement="right" @openChange="openChange"
        @confirm="pushWxskm">
        <template #description title="续费联系人付款">
            <a-spin :spinning="state.loading">
                <a-form-item label="需要支付金额" style="padding-top:10px">
                    <div>
                        <div v-if="state.cust_paid_editable">
                            <a-input v-model:value="state.paid_total" style="width: 80px"
                                @pressEnter="saveCustPrice()" />
                            <check-outlined class="editable-cell-icon-check" @click="saveCustPrice()" />
                        </div>
                        <div v-else>
                            <span style="font-size: 24px; color: red; line-height: 24px" class="red">￥{{
                                state.paid_total }}</span>
                            <edit-outlined class="editable-cell-icon" @click="editCustPrice()" />
                        </div>
                    </div>
                </a-form-item>
            </a-spin>
        </template>
        <slot>
            <!-- 默认内容，当父组件没有提供插槽内容时显示 -->
            <p>推送至微信收款</p>
        </slot>
    </a-popconfirm>
</template>
<script lang="ts" setup>
import { reactive, ref, onMounted, h, watch } from 'vue'
import { message } from 'ant-design-vue'
import { EditOutlined, CheckOutlined } from '@ant-design/icons-vue'
import baseService from '@/utils/http/axios'
const emit = defineEmits(['change'])
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => { }
    }
})
interface istate {
    loading: boolean
    cust_paid_editable: boolean
    paid_total: number
    public_payment_type: number
    fee_standard: number
    month_quantity: number
}
const state = reactive<istate>({
    loading: false,
    cust_paid_editable: false,
    paid_total: 0,
    public_payment_type: 1,
    fee_standard: 1,
    month_quantity: 12
})
onMounted(() => {
})
//编辑续4费联系人付
const editCustPrice = () => {
    state.cust_paid_editable = true
}
const openChange = (e) => {
    if (e) {
        //获取支付的类型，金额
        state.public_payment_type = props.tableColumnsData.first_pay_time ? (props.tableColumnsData.fee_standard == 2 ? 3 : 2) : 1
        state.fee_standard = props.tableColumnsData.fee_standard
        getComputeOreder()
    }
}
// 计算订单-地址续费
const getComputeOreder = () => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/getComputeOreder`,
        method: 'post',
        data: {
            public_payment_type: state.public_payment_type, //地址续费
            customer_id: props.tableColumnsData.id,
            month_quantity: state.month_quantity,
            fee_standard: state.fee_standard, //按年收费
            coupon_use_id: null
        }
    }
    baseService(requeryParam)
        .then((res: any) => {
            state.paid_total = res.data.oreder.cust_paid_total // 总实付金额（客户）
        })
        .catch((res) => {
            message.error(res?.msg ? res.msg : '查询订单失败')
        }).finally(() => {
            state.loading = false
        })
}
const saveCustPrice = () => {
    let requeryParam = {
        url: '/admin/v1/updateCustPaid',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id, //客户id
            new_price: state.paid_total,
            month_quantity: state.month_quantity,
            public_payment_type: state.public_payment_type
        }
    }
    baseService(requeryParam)
        .then((res: any) => {
            message.success(res.msg)
            state.cust_paid_editable = false
            emit('change', state.paid_total)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('修改失败')
            }
        })
}
//推送微信收款码
const pushWxskm = () => {
    let requestParam = {
        url: '/admin/v1/pushCustomerPayQrcode',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id,
            public_payment_type: state.public_payment_type
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
        })
}
</script>
